// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
import { CapicheEnvironment } from './capiche-environment.model';

export const environment: CapicheEnvironment = {
  envName: 'production',

  firebase: {
    apiKey: 'AIzaSyCzofJInrxiuemO6bhk-4OMc9pxl1ZCIxM',
    authDomain: 'capiche-2f764.firebaseapp.com',
    projectId: 'capiche-2f764',
    storageBucket: 'capiche-2f764.appspot.com',
    messagingSenderId: '221954728447',
    appId: '1:221954728447:web:7acf91556de1c9d11707ca',
    measurementId: 'G-69DGW9D5R6',
  },

  mainLogo: 'assets/brand/capiche-logo-production.svg',
  favicon: 'assets/brand/capiche-favicon-production.ico',
  production: true,
  useEmulator: false,
  // CSW-1445: functions moved us-central1 -> australia-southeast1 (2026-07-17).
  baseApiUrl: 'https://australia-southeast1-capiche-2f764.cloudfunctions.net/capicheApi',
  baseStripeApiUrl: 'https://stripeintegration-ito36r66cq-ts.a.run.app',

  // terms and conditions urls - these are hosted on the capiche website
  capicheAppTermsOfUseUrl: 'https://www.capiche-limited.com/capiche-app-terms-of-use',
  privacyPolicyUrl: 'https://www.capiche-limited.com/privacy-policy',

  //stripe price id
  stripePriceId: 'price_1QjojoG2zx7291ZyhKMgeJrG',

  //mixpanel
  mixpanelToken: 'e783c2a6c7220f82f732db0b5a2ea0bc',

  // teacher portal
  // capiche.app is NOT a domain Capiche owns or controls (confirmed CSW-1399/CSW-1469) —
  // capiche.web.app is the real production site.
  teacherPortalUrl: 'https://capiche.web.app/teacher',

  // admin portal
  adminPortalUrl: 'https://capiche.web.app/admin',

  // cross-app URLs
  capicheWebAppUrl: 'https://capiche.web.app',
  baseEducationApiUrl: 'https://australia-southeast1-capiche-2f764.cloudfunctions.net/capicheAdminApi/v1',

  // Chrome extension beta (CSW-1558/CSW-1573) — enabled in production too.
  // Testers need the extension in their actual daily-use context (the real
  // prod site, not the dev one), so the environment flag alone is no longer
  // the access control here — the per-user `extensionBeta` custom claim
  // (CSW-1564, checked in demo-page.component.ts) is. Wiring this in prod
  // does not expose the panel to ordinary users: without the claim,
  // showExtensionBeta$ still resolves false. CI publishes the zip on both
  // the development and production deploys (deploy-frontend.yml).
  extensionBeta: {
    enabled: true,
    basePath: '/beta',
  },
};
